import React from 'react';
import { compose } from '@beef/utils';
import { withRenderFlag } from '@beef/react';
import { connect } from 'react-redux';
import { ActionBar, Button } from '@beef/ui-kit';
import { handleSecondaryButtonClick } from "../../../store/actions/handleSecondaryButtonClick";
import { handleStepProgress } from "../../../store/actions/handleStepProgress";
import { getActiveButtonTexts, getIsLoading, selectActiveButtonByStepsText, selectIsButtonDisabled, shouldRenderModalButton, shouldShowSecondaryButton } from "../../../store/selectors";
var _ModalActionBar = function _ModalActionBar(_ref) {
  var secondButtonText = _ref.secondButtonText,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    onSecondaryButtonClick = _ref.onSecondaryButtonClick,
    isShowSecondaryButton = _ref.isShowSecondaryButton,
    activeButtonText = _ref.activeButtonText,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React.createElement(ActionBar, {
    size: "m",
    "data-t-id": "OrderTariffControl-ModalActionBar"
  }, activeButtonText && /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled,
    isLoading: isLoading,
    onClick: onClick
  }, activeButtonText), isShowSecondaryButton && /*#__PURE__*/React.createElement(Button, {
    onClick: onSecondaryButtonClick,
    variant: "tertiary"
  }, secondButtonText));
};
var mapStateToProps = function mapStateToProps(state) {
  var _getActiveButtonTexts;
  return {
    secondButtonText: (_getActiveButtonTexts = getActiveButtonTexts(state)) === null || _getActiveButtonTexts === void 0 ? void 0 : _getActiveButtonTexts.addressRequestSecondInlineForm,
    isLoading: getIsLoading(state),
    shouldRender: shouldRenderModalButton(state),
    activeButtonText: selectActiveButtonByStepsText(state),
    isShowSecondaryButton: shouldShowSecondaryButton(state),
    isDisabled: selectIsButtonDisabled(state)
  };
};
var mapDispatchToProps = {
  onClick: handleStepProgress,
  onSecondaryButtonClick: handleSecondaryButtonClick
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var ModalActionBar = compose(connector, withRenderFlag)(_ModalActionBar);